type Source = { label: string; data: unknown; isError: boolean; isPending: boolean; isFetching: boolean };

/** Fail closed when the API caps an unpaged financial source. */
export function assertCompleteRows(result: { data: unknown[] | null; count: number | null }, label: string) {
  if (result.count === null || result.data === null || result.data.length !== result.count) {
    throw new Error(`${label} is incomplete. The full dataset is needed before showing totals.`);
  }
}

export function aggregateState(sources: Source[]) {
  const failed = sources.filter((s) => s.isError).map((s) => s.label);
  return {
    failed,
    loading: !failed.length && sources.some((s) => s.isPending || s.data === undefined),
    refreshing: sources.some((s) => s.isFetching),
    available: sources.every((s) => !s.isError && !s.isPending && s.data !== undefined),
  };
}
